module.exports = "<lfwms-searchable-entity-dynamic-details [serviceFactory]=\"serviceFactory\"></lfwms-searchable-entity-dynamic-details>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-details/reports-configuration-details.component.html
// module id = ../../../../../src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-details/reports-configuration-details.component.html
// module chunks = main